import React from 'react';
import { Link } from 'react-router-dom';
import { toCalendrier, toSmallCalendrier } from '../../App_Code/Utils';
import PopupTelecharger from '../PopupTelecharger';

const Card = ({ Titre, SousTitre, children }) => (
    <div className="card mb-3">
        <div className="card-body ligne-doc">
            {/* <h5 className="card-title">{Titre}</h5>
            <h6 className="card-subtitle mb-2 text-muted">{SousTitre}</h6> */}
            {children}
        </div>
    </div>
);

const InformationPillule = ({
    AjouterFiltre, Badge, Valeur, ExtraClass,
}) => {
    if (!Valeur) return null;

    return (
        <button
            onClick={(event) => {
                event.preventDefault();
                AjouterFiltre(Valeur);
            }}
            className={`btn badge badge-pill ${Badge} mr-2`}
        >
            {ExtraClass && <i className={ExtraClass} title={Valeur} />} {Valeur}
        </button>
    );
};

const Details = ({
    Type, Prest, Act, VisiblePar, DateDeb, actions, TypeLib,
}) => {
    const icone = Type === 0 ? 'fa-file-alt' : 'fa-envelope';

    const AjoutFiltreAct = (filtre) => {
        actions.docFiltrePrest(Prest);
        actions.docFiltreAct(filtre);
    };

    return (
        <div className="media">
            <div className="mr-3">
                <i className={`far fa-2x text-dark ${icone}`} title={`${TypeLib}`} />
            </div>
            <div className="media-body">
                <InformationPillule AjouterFiltre={actions.docFiltrePrest} Badge="badge-primary" Valeur={Prest} />
                <InformationPillule AjouterFiltre={AjoutFiltreAct} Badge="badge-success" Valeur={Act} />
                <span className={`badge badge-pill ${VisiblePar.Couleur}`} title={VisiblePar.Legende}>
                    <i className={VisiblePar.Icone} /> {VisiblePar.Titre}
                </span>
                {/* <span className="text-muted mb-0">&nbsp;{toCalendrier(DateDeb)}</span> */}
            </div>
        </div>
    );
};

const Boutons = ({ Doc }) => (
    <React.Fragment>
        <button type="button" className="btn btn-outline-primary mt-1 mr-3" onClick={() => PopupTelecharger(Doc.Id)}>
            <i className="fa fas fa-download" /> Télécharger
        </button>
        <Link
            to={{
                pathname: '/MesDocuments/Document',
                state: { Id: Doc.Id },
            }}
            className="btn btn-outline-dark mt-1 mr-3"
        >
            <i className="fa fas fa-eye" /> Visualiser
        </Link>
        {Doc.Type === 1 && (
            <Link
                to={{
                    pathname: '/MesDocuments/SuiviCourrier',
                    state: { Id: Doc.Id, TypeLib: Doc.TypeLib },
                }}
                title="Informations complémentaires sur l'envoi"
                className="btn btn-outline-secondary mt-1"
            >
                <i className="fas fa-info-circle" /> Infos
            </Link>
        )}
    </React.Fragment>
);

const CardDocumentLigne = ({ Doc, actions }) => (
    <div className="col-xl-12 col-md-12 col-sm-12">
        <Card Titre={Doc.Objet} SousTitre={Doc.TypeLib}>
            <div className="row">
                <div className="col-xl-4 col-md-6 col-sm-12">
                    <span className="text-muted mb-0">{toSmallCalendrier(Doc.DateDeb)}&nbsp;</span>
                    <h5 className="card-title titre-enligne">{Doc.Objet}</h5>
                    {/* <h6 className="card-subtitle mb-2 text-muted titre-enligne">{Doc.TypeLib}</h6> */}
                </div>
                <div className="col-xl-4 col-md-6 col-sm-12">
                    <div className="card-text">
                        <Details {...Doc} actions={actions} />
                    </div>
                </div>
                <div className="col-xl-4 col-md-6 col-sm-12"><Boutons Doc={Doc} /></div>
            </div>    
        </Card>
    </div>
);

export default CardDocumentLigne;



// WEBPACK FOOTER //
// ./src/components/MesDocs/CardDocumentLigne.js